import { type SurveyRecord } from '../../../schemas/api/survey';
import { baseSurveys, termsAndConditionsHtml } from '../fixtures/content';
import { clone } from '../support/clone';

/**
 * Returns mock surveys. Filters by code if provided.
 */
export function getDevMockSurveys(code?: string): SurveyRecord[] {
  const list = code ? baseSurveys.filter((survey) => survey.code === code || code === 'invite123') : baseSurveys;
  return clone(list).map(({ code: _code, ...survey }) => survey);
}

/**
 * Returns the mock terms and conditions HTML.
 */
export function getDevMockTermsHtml(): string {
  return termsAndConditionsHtml;
}
